export default __webpack_public_path__ + "static/media/internshipSnap.691a5e10.svg";